import { isCardCarousel, mapCardCarouselItems } from '../helpers/yacht-cards'
import { buildPriceFrequencyStringFromFrequency } from '../proposals/yachts'

export const cardYacht = ({
  id,
  amenities = [],
  cabins = 0,
  frequency = '',
  guests = 0,
  heading = '',
  href = '',
  image = '',
  isCharter = false,
  isFeatured = false,
  lengthMetres = 0,
  listingType = '',
  mediaHover,
  price = 0,
  subheading = '',
  badges,
  description,
  subtitle,
  cardCarousel = [],
  disableCardMediaGallery,
  trackEventName,
}: any) => ({
  id,
  amenities,
  cabins,
  frequency,
  guests,
  heading,
  href,
  image,
  isCharter,
  isFeatured,
  lengthMetres,
  listingType,
  mediaHover,
  price,
  subheading,
  frequencyString: '',
  badges,
  description,
  subtitle,
  cardCarousel,
  disableCardMediaGallery,
  hasCarousel: false,
  cardCarouselItems: [] as any[],
  trackEventName,

  init() {
    if (
      isCardCarousel({
        items: cardCarousel,
        disableCarousel: disableCardMediaGallery,
      })
    ) {
      this.hasCarousel = true
      this.cardCarouselItems = mapCardCarouselItems(
        {
          items: cardCarousel,
        },
        {
          heading,
          firstItem: image,
        },
      )
    }

    this.frequencyString = buildPriceFrequencyStringFromFrequency(
      isCharter,
      frequency,
    )
  },
})
